import "./App.css";
import MeetingInfo from "./MeetingInfo";
import HomePage from "./HomePage";

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { DataProvider } from "./DataContext";
// import MeetingInfo from './MeetingInfo';

function App() {
    return (
        <DataProvider>
            <Router>
                <Routes>
                    <Route path='/data-display' element={<MeetingInfo />} />
                    <Route path='/' element={<HomePage />}></Route>
                </Routes>
            </Router>
        </DataProvider>
    );
}

export default App;
